(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ela-campaign-film"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ela-campaign-film')) {
    customElements.define('ela-campaign-film', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.control = this.querySelector('.ela-film__control');
        if (!this.video || !this.control) return;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduceMotion) {
          this.video.pause();
          this.sync(false);
        }
        this.control.addEventListener('click', () => {
          if (this.video.paused) this.video.play();
          else this.video.pause();
          this.sync(!this.video.paused);
        });
      }
      sync(playing) {
        this.control.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
        this.control.querySelector('span').textContent = playing ? 'Ⅱ' : '▶';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ela-countdown-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ela-launch-countdown')) {
    customElements.define('ela-launch-countdown', class extends HTMLElement {
      connectedCallback() {
        const deadline = Date.parse(this.dataset.deadline);
        if (!Number.isFinite(deadline)) return;
        const digits = this.querySelector('.ela-countdown__digits');
        const expired = this.querySelector('[data-expired]');
        const signup = this.querySelector('[data-prelaunch-signup]');
        const purchase = this.querySelector('[data-launch-purchase]');
        const hydratePurchase = async () => {
          if (!purchase || purchase.dataset.ready === 'true' || purchase.dataset.loading === 'true') return;
          const productUrl = new URL(this.dataset.productUrl || '', window.location.origin);
          const handle = productUrl.pathname.split('/products/')[1]?.split('/')[0];
          const input = purchase.querySelector('input[name="id"]');
          const button = purchase.querySelector('button[name="add"]');
          if (!handle || !input || !button) return;
          purchase.dataset.loading = 'true';
          try {
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error(`Product request failed: ${response.status}`);
            const product = await response.json();
            const variant = product.variants.find((item) => item.available) || product.variants[0];
            if (!variant) throw new Error('Product has no variants');
            input.value = String(variant.id);
            button.disabled = !variant.available;
            button.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
            purchase.dataset.ready = 'true';
          } catch (error) {
            button.disabled = true;
            console.error('[ELA launch purchase]', error);
          } finally {
            delete purchase.dataset.loading;
          }
        };
        const update = () => {
          const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
          digits.hidden = remaining === 0;
          expired.hidden = remaining !== 0;
          if (signup) signup.hidden = remaining === 0;
          if (purchase) purchase.hidden = remaining !== 0;
          if (remaining === 0) hydratePurchase();
          const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
          for (const [unit, value] of Object.entries(values)) this.querySelector(`[data-unit="${unit}"]`).textContent = String(value).padStart(2, '0');
          if (!remaining) clearInterval(this.timer);
        };
        this.timer = setInterval(update, 1000);
        update();
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }
  document.querySelectorAll('[data-ela-launch-sticky]').forEach((sticky) => {
    if (sticky.dataset.ready === 'true') return;
    sticky.dataset.ready = 'true';
    const source = document.getElementById(sticky.dataset.elaLaunchSource);
    const field = document.querySelector(sticky.getAttribute('href'));
    if (!source || !field) return;
    const setVisible = (visible) => {
      sticky.dataset.visible = visible ? 'true' : 'false';
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      sticky.tabIndex = visible ? 0 : -1;
    };
    new IntersectionObserver(([entry]) => setVisible(!entry.isIntersecting), { threshold: 0.08 }).observe(source);
    sticky.addEventListener('click', (event) => {
      event.preventDefault();
      source.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      setTimeout(() => field.focus({ preventScroll: true }), 450);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ela-countdown-v3"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ela-launch-countdown')) {
    customElements.define('ela-launch-countdown', class extends HTMLElement {
      connectedCallback() {
        const deadline = Date.parse(this.dataset.deadline);
        if (!Number.isFinite(deadline)) return;
        const digits = this.querySelector('.ela-countdown__digits');
        const expired = this.querySelector('[data-expired]');
        const signup = this.querySelector('[data-prelaunch-signup]');
        const purchase = this.querySelector('[data-launch-purchase]');
        const hydratePurchase = async () => {
          if (!purchase || purchase.dataset.ready === 'true' || purchase.dataset.loading === 'true') return;
          const productUrl = new URL(this.dataset.productUrl || '', window.location.origin);
          const handle = productUrl.pathname.split('/products/')[1]?.split('/')[0];
          const input = purchase.querySelector('input[name="id"]');
          const button = purchase.querySelector('button[name="add"]');
          if (!handle || !input || !button) return;
          purchase.dataset.loading = 'true';
          try {
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error(`Product request failed: ${response.status}`);
            const product = await response.json();
            const variant = product.variants.find((item) => item.available) || product.variants[0];
            if (!variant) throw new Error('Product has no variants');
            input.value = String(variant.id);
            button.disabled = !variant.available;
            button.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
            purchase.dataset.ready = 'true';
          } catch (error) {
            button.disabled = true;
            console.error('[ELA launch purchase]', error);
          } finally {
            delete purchase.dataset.loading;
          }
        };
        const update = () => {
          const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
          digits.hidden = remaining === 0;
          expired.hidden = remaining !== 0;
          if (signup) signup.hidden = remaining === 0;
          if (purchase) purchase.hidden = remaining !== 0;
          if (remaining === 0) hydratePurchase();
          const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
          for (const [unit, value] of Object.entries(values)) this.querySelector(`[data-unit="${unit}"]`).textContent = String(value).padStart(2, '0');
          if (!remaining) clearInterval(this.timer);
        };
        this.timer = setInterval(update, 1000);
        update();
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }
  document.querySelectorAll('[data-ela-launch-sticky]').forEach((sticky) => {
    if (sticky.dataset.ready === 'true') return;
    sticky.dataset.ready = 'true';
    const source = document.getElementById(sticky.dataset.elaLaunchSource);
    const field = document.querySelector(sticky.getAttribute('href'));
    if (!source || !field) return;
    const setVisible = (visible) => {
      sticky.dataset.visible = visible ? 'true' : 'false';
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      sticky.tabIndex = visible ? 0 : -1;
    };
    const closingSection = document.querySelector('[id*="ela_house_world"]') || document.querySelector('footer');
    let sourceVisible = true;
    let closingVisible = false;
    const syncVisibility = () => setVisible(!sourceVisible && !closingVisible);
    new IntersectionObserver(([entry]) => {
      sourceVisible = entry.isIntersecting;
      syncVisibility();
    }, { threshold: 0.08 }).observe(source);
    if (closingSection) {
      new IntersectionObserver(([entry]) => {
        closingVisible = entry.isIntersecting;
        syncVisibility();
      }, { threshold: 0.04 }).observe(closingSection);
    }
    sticky.addEventListener('click', (event) => {
      event.preventDefault();
      source.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      setTimeout(() => field.focus({ preventScroll: true }), 450);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ela-countdown-v4"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ela-launch-countdown')) {
    customElements.define('ela-launch-countdown', class extends HTMLElement {
      connectedCallback() {
        const deadline = Date.parse(this.dataset.deadline);
        if (!Number.isFinite(deadline)) return;
        const digits = this.querySelector('.ela-countdown__digits');
        const expired = this.querySelector('[data-expired]');
        const signup = this.querySelector('[data-prelaunch-signup]');
        const purchase = this.querySelector('[data-launch-purchase]');
        const hydratePurchase = async () => {
          if (!purchase || purchase.dataset.ready === 'true' || purchase.dataset.loading === 'true') return;
          const productUrl = new URL(this.dataset.productUrl || '', window.location.origin);
          const handle = productUrl.pathname.split('/products/')[1]?.split('/')[0];
          const input = purchase.querySelector('input[name="id"]');
          const button = purchase.querySelector('button[name="add"]');
          if (!handle || !input || !button) return;
          purchase.dataset.loading = 'true';
          try {
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error(`Product request failed: ${response.status}`);
            const product = await response.json();
            const variant = product.variants.find((item) => item.available) || product.variants[0];
            if (!variant) throw new Error('Product has no variants');
            input.value = String(variant.id);
            button.disabled = !variant.available;
            button.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
            purchase.dataset.ready = 'true';
          } catch (error) {
            button.disabled = true;
            console.error('[ELA launch purchase]', error);
          } finally {
            delete purchase.dataset.loading;
          }
        };
        const update = () => {
          const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
          digits.hidden = remaining === 0;
          expired.hidden = remaining !== 0;
          if (signup) signup.hidden = remaining === 0;
          if (purchase) purchase.hidden = remaining !== 0;
          if (remaining === 0) hydratePurchase();
          const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
          for (const [unit, value] of Object.entries(values)) this.querySelector(`[data-unit="${unit}"]`).textContent = String(value).padStart(2, '0');
          if (!remaining) clearInterval(this.timer);
        };
        this.timer = setInterval(update, 1000);
        update();
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }
  document.querySelectorAll('[data-ela-launch-sticky]').forEach((sticky) => {
    if (sticky.dataset.ready === 'true') return;
    sticky.dataset.ready = 'true';
    const source = document.getElementById(sticky.dataset.elaLaunchSource);
    const field = document.querySelector(sticky.getAttribute('href'));
    if (!source || !field) return;
    const setVisible = (visible) => {
      sticky.dataset.visible = visible ? 'true' : 'false';
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      sticky.tabIndex = visible ? 0 : -1;
    };
    const closingBoundary = document.querySelector('.ela-gateway') || document.querySelector('.ela-shop-now');
    let sourceVisible = true;
    let framePending = false;
    const syncVisibility = () => {
      const purchaseJourneyReached = closingBoundary && closingBoundary.getBoundingClientRect().top <= window.innerHeight;
      setVisible(!sourceVisible && !purchaseJourneyReached);
      framePending = false;
    };
    const requestSync = () => {
      if (framePending) return;
      framePending = true;
      requestAnimationFrame(syncVisibility);
    };
    new IntersectionObserver(([entry]) => {
      sourceVisible = entry.isIntersecting;
      requestSync();
    }, { threshold: 0.08 }).observe(source);
    addEventListener('scroll', requestSync, { passive: true });
    addEventListener('resize', requestSync, { passive: true });
    requestSync();
    sticky.addEventListener('click', (event) => {
      event.preventDefault();
      source.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      setTimeout(() => field.focus({ preventScroll: true }), 450);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ela-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ela-launch-countdown')) {
    customElements.define('ela-launch-countdown', class extends HTMLElement {
      connectedCallback() {
        const deadline = Date.parse(this.dataset.deadline);
        if (!Number.isFinite(deadline)) return;
        const digits = this.querySelector('.ela-countdown__digits');
        const expired = this.querySelector('[data-expired]');
        const signup = this.querySelector('[data-prelaunch-signup]');
        const purchase = this.querySelector('[data-launch-purchase]');
        const hydratePurchase = async () => {
          if (!purchase || purchase.dataset.ready === 'true' || purchase.dataset.loading === 'true') return;
          const productUrl = new URL(this.dataset.productUrl || '', window.location.origin);
          const handle = productUrl.pathname.split('/products/')[1]?.split('/')[0];
          const input = purchase.querySelector('input[name="id"]');
          const button = purchase.querySelector('button[name="add"]');
          if (!handle || !input || !button) return;
          purchase.dataset.loading = 'true';
          try {
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error(`Product request failed: ${response.status}`);
            const product = await response.json();
            const variant = product.variants.find((item) => item.available) || product.variants[0];
            if (!variant) throw new Error('Product has no variants');
            input.value = String(variant.id);
            button.disabled = !variant.available;
            button.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
            purchase.dataset.ready = 'true';
          } catch (error) {
            button.disabled = true;
            console.error('[ELA launch purchase]', error);
          } finally {
            delete purchase.dataset.loading;
          }
        };
        const update = () => {
          const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
          digits.hidden = remaining === 0;
          expired.hidden = remaining !== 0;
          if (signup) signup.hidden = remaining === 0;
          if (purchase) purchase.hidden = remaining !== 0;
          if (remaining === 0) hydratePurchase();
          const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
          for (const [unit, value] of Object.entries(values)) this.querySelector(`[data-unit="${unit}"]`).textContent = String(value).padStart(2, '0');
          if (!remaining) clearInterval(this.timer);
        };
        this.timer = setInterval(update, 1000);
        update();
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }
  document.querySelectorAll('[data-ela-launch-sticky]').forEach((sticky) => {
    if (sticky.dataset.ready === 'true') return;
    sticky.dataset.ready = 'true';
    const source = document.getElementById(sticky.dataset.elaLaunchSource);
    const field = document.querySelector(sticky.getAttribute('href'));
    if (!source || !field) return;
    const setVisible = (visible) => {
      sticky.dataset.visible = visible ? 'true' : 'false';
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      sticky.tabIndex = visible ? 0 : -1;
    };
    new IntersectionObserver(([entry]) => setVisible(!entry.isIntersecting), { threshold: 0.08 }).observe(source);
    sticky.addEventListener('click', (event) => {
      event.preventDefault();
      source.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      setTimeout(() => field.focus({ preventScroll: true }), 450);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ela-product-launch-gate"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ela-product-launch-gate')) {
    customElements.define('ela-product-launch-gate', class extends HTMLElement {
      connectedCallback() {
        const deadline = Date.parse(this.dataset.launchAt);
        if (!Number.isFinite(deadline)) return;
        const update = () => {
          const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
          if (!remaining) {
            document.getElementById(this.dataset.styleId)?.remove();
            document.querySelectorAll('[data-ela-prelaunch-cta]').forEach((element) => element.remove());
            this.remove();
            clearInterval(this.timer);
            return;
          }
          const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
          for (const [unit, value] of Object.entries(values)) this.querySelector(`[data-unit="${unit}"]`).textContent = String(value).padStart(2, '0');
        };
        this.timer = setInterval(update, 1000);
        update();
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ela-scroll-film-v2"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('ela-layered-story'))customElements.define('ela-layered-story',class extends HTMLElement{connectedCallback(){this.background=this.querySelector('.ela-layered-story__background');this.box=this.querySelector('.ela-layered-story__box');this.product=this.querySelector('.ela-layered-story__product');this.effect=this.querySelector('.ela-layered-story__effect');this.bar=this.querySelector('.ela-layered-story__progress span');this.chapters=[...this.querySelectorAll('[data-chapter]')];this.style.setProperty('--ela-chapter-count',Math.max(1,this.chapters.length));this.reducedMotion=matchMedia('(prefers-reduced-motion: reduce)').matches;this.onMove=()=>{if(this.frame||this.reducedMotion||!this.active)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.update()})};this.observer=new IntersectionObserver(([entry])=>{this.active=entry.isIntersecting;if(this.active)this.update()},{rootMargin:'100% 0px'});this.observer.observe(this);addEventListener('scroll',this.onMove,{passive:true});addEventListener('resize',this.onMove,{passive:true})}clamp(value,min=0,max=1){return Math.min(max,Math.max(min,value))}update(){if(!this.active||this.reducedMotion)return;const rect=this.getBoundingClientRect();const travel=Math.max(1,this.offsetHeight-innerHeight);const progress=this.clamp(-rect.top/travel);const productStart=Number(this.dataset.productStart)/100;const productEnd=Number(this.dataset.productEnd)/100;const reveal=this.clamp((progress-productStart)/Math.max(.01,productEnd-productStart));const mobile=innerWidth<=749;const productBase=mobile ? .78 : 1;const boxBase=mobile ? .72 : 1;const productScale=productBase*(1+reveal*(Number(this.dataset.productScale)/100-1));this.background.style.transform=`scale(${1.03+progress*.18}) translate3d(0,${progress*2}%,0)`;this.product.style.transform=`translate3d(0,${(1-reveal)*34}%,0) scale(${productScale})`;if(this.box){const boxEnd=Math.max(.01,Number(this.dataset.boxEnd)/100);const boxProgress=this.clamp(progress/boxEnd);this.box.style.transform=`translate3d(0,${boxProgress*86}%,0) scale(${boxBase*(1-boxProgress*.08)})`;this.box.style.opacity=String(this.clamp(1-(boxProgress-.68)/.32))}if(this.effect){const effectStart=Number(this.dataset.effectStart)/100;const effectProgress=this.clamp((progress-effectStart)/Math.max(.01,1-effectStart));this.effect.style.opacity=String(effectProgress);this.effect.style.transform=`scale(${.82+effectProgress*.28}) rotate(${(1-effectProgress)*-3}deg)`}const segment=progress*Math.max(1,this.chapters.length-1);const lower=Math.floor(segment);const local=segment-lower;const blend=this.clamp((local-.44)/.12);this.chapters.forEach((chapter,index)=>{let opacity=0;if(index===lower)opacity=1-blend;if(index===Math.min(lower+1,this.chapters.length-1))opacity=Math.max(opacity,blend);chapter.style.opacity=String(opacity);chapter.style.transform=`translate3d(0,${(1-opacity)*14}px,0)`;chapter.style.visibility=opacity>.02?'visible':'hidden'});this.bar.style.width=`${100*progress}%`}disconnectedCallback(){this.observer?.disconnect();removeEventListener('scroll',this.onMove);removeEventListener('resize',this.onMove);if(this.frame)cancelAnimationFrame(this.frame)}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ela-scroll-film-v3"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('ela-layered-story'))customElements.define('ela-layered-story',class extends HTMLElement{connectedCallback(){this.background=this.querySelector('.ela-layered-story__background');this.box=this.querySelector('.ela-layered-story__box');this.product=this.querySelector('.ela-layered-story__product');this.effect=this.querySelector('.ela-layered-story__effect');this.bar=this.querySelector('.ela-layered-story__progress span');this.chapters=[...this.querySelectorAll('[data-chapter]')];this.style.setProperty('--ela-chapter-count',Math.max(1,this.chapters.length));this.reducedMotion=matchMedia('(prefers-reduced-motion: reduce)').matches;this.onMove=()=>{if(this.frame||this.reducedMotion||!this.active)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.update()})};this.observer=new IntersectionObserver(([entry])=>{this.active=entry.isIntersecting;if(this.active)this.update()},{rootMargin:'100% 0px'});this.observer.observe(this);addEventListener('scroll',this.onMove,{passive:true});addEventListener('resize',this.onMove,{passive:true})}clamp(value,min=0,max=1){return Math.min(max,Math.max(min,value))}update(){if(!this.active||this.reducedMotion)return;const rect=this.getBoundingClientRect();const travel=Math.max(1,this.offsetHeight-innerHeight);const progress=this.clamp(-rect.top/travel);const productStart=Number(this.dataset.productStart)/100;const productEnd=Number(this.dataset.productEnd)/100;const reveal=this.clamp((progress-productStart)/Math.max(.01,productEnd-productStart));const mobile=innerWidth<=749;const productBase=mobile ? .78 : 1;const boxBase=mobile ? .72 : 1;const productScale=productBase*(1+reveal*(Number(this.dataset.productScale)/100-1));this.background.style.transform=`scale(${1.03+progress*.18}) translate3d(0,${progress*2}%,0)`;this.product.style.transform=`translate3d(0,${(1-reveal)*34}%,0) scale(${productScale})`;if(this.box){const boxEnd=Math.max(.01,Number(this.dataset.boxEnd)/100);const boxProgress=this.clamp(progress/boxEnd);this.box.style.transform=`translate3d(0,${boxProgress*86}%,0) scale(${boxBase*(1-boxProgress*.08)})`;this.box.style.opacity=String(this.clamp(1-(boxProgress-.68)/.32))}if(this.effect){const effectStart=Number(this.dataset.effectStart)/100;const effectProgress=this.clamp((progress-effectStart)/Math.max(.01,1-effectStart));this.effect.style.opacity=String(effectProgress);this.effect.style.transform=`scale(${.82+effectProgress*.28}) rotate(${(1-effectProgress)*-3}deg)`}const segment=progress*Math.max(1,this.chapters.length-1);const lower=Math.floor(segment);const local=segment-lower;const blend=this.clamp((local-.44)/.12);this.chapters.forEach((chapter,index)=>{let opacity=0;if(index===lower)opacity=1-blend;if(index===Math.min(lower+1,this.chapters.length-1))opacity=Math.max(opacity,blend);chapter.style.opacity=String(opacity);chapter.style.transform=`translate3d(0,${(1-opacity)*14}px,0)`;chapter.style.visibility=opacity>.02?'visible':'hidden'});this.bar.style.width=`${100*progress}%`}disconnectedCallback(){this.observer?.disconnect();removeEventListener('scroll',this.onMove);removeEventListener('resize',this.onMove);if(this.frame)cancelAnimationFrame(this.frame)}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ela-scroll-film-v4"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ela-motion-journey')) customElements.define('ela-motion-journey', class extends HTMLElement {
    connectedCallback(){this.chapters=[...this.querySelectorAll('[data-chapter]')];this.counter=this.querySelector('.ela-motion__rail-count b');this.motionMedia=matchMedia('(prefers-reduced-motion: reduce)');this.reducedMotion=this.motionMedia.matches;this.onMotionPreference=(event)=>{this.reducedMotion=event.matches;this.requestUpdate()};this.motionMedia.addEventListener?.('change',this.onMotionPreference);this.onMove=()=>this.requestUpdate();this.observer=new IntersectionObserver(([entry])=>{this.active=entry.isIntersecting;if(this.active)this.requestUpdate()},{rootMargin:'100% 0px'});this.observer.observe(this);addEventListener('scroll',this.onMove,{passive:true});addEventListener('resize',this.onMove,{passive:true});this.requestUpdate()}
    clamp(value,min=0,max=1){return Math.min(max,Math.max(min,value))}
    requestUpdate(){if(this.frame||this.reducedMotion||!this.active)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.update()})}
    update(){const rect=this.getBoundingClientRect();const travel=Math.max(1,this.offsetHeight-innerHeight);const progress=this.clamp(-rect.top/travel);const productStart=Number(this.dataset.productStart)/100;const productEnd=Number(this.dataset.productEnd)/100;const boxEnd=Math.max(.01,Number(this.dataset.boxEnd)/100);const effectStart=Number(this.dataset.effectStart)/100;const reveal=this.clamp((progress-productStart)/Math.max(.01,productEnd-productStart));const boxProgress=this.clamp(progress/boxEnd);const effectProgress=this.clamp((progress-effectStart)/Math.max(.01,1-effectStart));this.style.setProperty('--ela-p',progress.toFixed(4));this.style.setProperty('--ela-reveal',reveal.toFixed(4));this.style.setProperty('--ela-box-p',boxProgress.toFixed(4));this.style.setProperty('--ela-effect-p',effectProgress.toFixed(4));const maxIndex=Math.max(0,this.chapters.length-1);const position=progress*Math.max(1,this.chapters.length);const activeIndex=Math.min(maxIndex,Math.floor(position));const local=position-activeIndex;this.chapters.forEach((chapter,index)=>{let opacity=index===activeIndex?1:0;if(index===activeIndex&&activeIndex<maxIndex&&local>.68)opacity=1-this.clamp((local-.68)/.22);if(index===activeIndex+1&&local>.68)opacity=this.clamp((local-.68)/.22);if(progress>=.999&&index===maxIndex)opacity=1;chapter.style.opacity=opacity.toFixed(3);chapter.style.transform=`translate3d(0,${((1-opacity)*22).toFixed(2)}px,0)`;chapter.classList.toggle('is-active',opacity>.02)});if(this.counter)this.counter.textContent=`0${activeIndex+1}`}
    disconnectedCallback(){this.observer?.disconnect();removeEventListener('scroll',this.onMove);removeEventListener('resize',this.onMove);this.motionMedia?.removeEventListener?.('change',this.onMotionPreference);if(this.frame)cancelAnimationFrame(this.frame)}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ela-scroll-film"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('ela-layered-story'))customElements.define('ela-layered-story',class extends HTMLElement{connectedCallback(){this.background=this.querySelector('.ela-layered-story__background');this.box=this.querySelector('.ela-layered-story__box');this.product=this.querySelector('.ela-layered-story__product');this.effect=this.querySelector('.ela-layered-story__effect');this.bar=this.querySelector('.ela-layered-story__progress span');this.chapters=[...this.querySelectorAll('[data-chapter]')];this.style.setProperty('--ela-chapter-count',Math.max(1,this.chapters.length));this.reducedMotion=matchMedia('(prefers-reduced-motion: reduce)').matches;this.onMove=()=>{if(this.frame||this.reducedMotion||!this.active)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.update()})};this.observer=new IntersectionObserver(([entry])=>{this.active=entry.isIntersecting;if(this.active)this.update()},{rootMargin:'100% 0px'});this.observer.observe(this);addEventListener('scroll',this.onMove,{passive:true});addEventListener('resize',this.onMove,{passive:true})}clamp(value,min=0,max=1){return Math.min(max,Math.max(min,value))}update(){if(!this.active||this.reducedMotion)return;const rect=this.getBoundingClientRect();const travel=Math.max(1,this.offsetHeight-innerHeight);const progress=this.clamp(-rect.top/travel);const productStart=Number(this.dataset.productStart)/100;const productEnd=Number(this.dataset.productEnd)/100;const reveal=this.clamp((progress-productStart)/Math.max(.01,productEnd-productStart));const mobile=innerWidth<=749;const productBase=mobile ? .78 : 1;const boxBase=mobile ? .72 : 1;const productScale=productBase*(1+reveal*(Number(this.dataset.productScale)/100-1));this.background.style.transform=`scale(${1.03+progress*.18}) translate3d(0,${progress*2}%,0)`;this.product.style.transform=`translate3d(0,${(1-reveal)*34}%,0) scale(${productScale})`;if(this.box){const boxEnd=Math.max(.01,Number(this.dataset.boxEnd)/100);const boxProgress=this.clamp(progress/boxEnd);this.box.style.transform=`translate3d(0,${boxProgress*86}%,0) scale(${boxBase*(1-boxProgress*.08)})`;this.box.style.opacity=String(this.clamp(1-(boxProgress-.68)/.32))}if(this.effect){const effectStart=Number(this.dataset.effectStart)/100;const effectProgress=this.clamp((progress-effectStart)/Math.max(.01,1-effectStart));this.effect.style.opacity=String(effectProgress);this.effect.style.transform=`scale(${.82+effectProgress*.28}) rotate(${(1-effectProgress)*-3}deg)`}const segment=progress*Math.max(1,this.chapters.length-1);const lower=Math.floor(segment);const local=segment-lower;const blend=this.clamp((local-.44)/.12);this.chapters.forEach((chapter,index)=>{let opacity=0;if(index===lower)opacity=1-blend;if(index===Math.min(lower+1,this.chapters.length-1))opacity=Math.max(opacity,blend);chapter.style.opacity=String(opacity);chapter.style.transform=`translate3d(0,${(1-opacity)*14}px,0)`;chapter.style.visibility=opacity>.02?'visible':'hidden'});this.bar.style.width=`${100*progress}%`}disconnectedCallback(){this.observer?.disconnect();removeEventListener('scroll',this.onMove);removeEventListener('resize',this.onMove);if(this.frame)cancelAnimationFrame(this.frame)}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ela-scroll-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ela-scroll-story')) {
    customElements.define('ela-scroll-story', class extends HTMLElement {
      connectedCallback() {
        const images = [...this.querySelectorAll('[data-scene]')];
        const chapters = [...this.querySelectorAll('[data-scene-trigger]')];
        const activate = index => images.forEach(image => image.toggleAttribute('data-active', Number(image.dataset.scene) === index));
        activate(0);
        this.observer = new IntersectionObserver(entries => {
          const visible = entries.filter(entry => entry.isIntersecting).sort((a,b) => b.intersectionRatio - a.intersectionRatio)[0];
          if (visible) activate(Number(visible.target.dataset.sceneTrigger));
        }, { threshold: [.35,.55,.75] });
        chapters.forEach(chapter => this.observer.observe(chapter));
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ela-service-rail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ela-service-rail')) {
    customElements.define('ela-service-rail', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.index = 0;
        this.delay = Math.max(Number(this.dataset.delay) || 5000, 3000);
        this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.start();
      }
      disconnectedCallback() { this.stop(); }
      show(next) {
        if (this.slides.length < 2) return;
        this.slides[this.index]?.removeAttribute('data-active');
        this.slides[this.index]?.setAttribute('aria-hidden', 'true');
        this.index = (next + this.slides.length) % this.slides.length;
        this.slides[this.index]?.setAttribute('data-active', 'true');
        this.slides[this.index]?.removeAttribute('aria-hidden');
        this.start();
      }
      start() {
        this.stop();
        if (!this.reduceMotion && this.slides.length > 1) this.timer = setInterval(() => this.show(this.index + 1), this.delay);
      }
      stop() { if (this.timer) clearInterval(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
